<template>
    <div class="shopping-cart" v-loading="loading">
        <h3 class="mt-0 mb-5 text-center" v-if="withHeader">Shopping Cart</h3>
        <template v-if="showProducts">
            <div
                class="mt-20"
                v-for="(item, order_id) in orders"
                :key="order_id"
            >
                <template v-if="item.calendar">
                    <span
                        ><h3 class="mt-0 mb-0">
                            {{ item.calendar.name
                            }}{{ item.calendar.is_weekly ? " Weekly" : "" }}
                            Calendar
                        </h3>
                        <el-button
                            v-if="showAddProducts"
                            type="secondary"
                            round
                            @click="goToAddCalendarProducts(order.calendar_id)"
                            size="small"
                            style="margin-left: 10px"
                            icon="mdi mdi-basket-plus"
                        >
                            Add Products
                        </el-button></span
                    >
                    <div
                        class="shopping-cart__row"
                        v-for="(size, size_id) in item.sizes"
                        :key="`size-${size_id}`"
                    >
                        <div class="cart-left">
                            <b>{{ size.quantity }}</b> - {{ size.name }}
                            <span v-if="size.color_type === ColorTypes.COLORED"
                                >Color</span
                            ><span v-else>Black Ink</span>
                            <span v-if="size.type === SizeTypes.FLAT"
                                >Cop<span v-if="size.quantity > 1">ies</span
                                ><span v-else>y</span></span
                            ><span v-else
                                >Poster<span v-if="size.quantity > 1"
                                    >s</span
                                ></span
                            >
                            <div
                                class="paper-color"
                                title="Paper Color"
                                v-if="size.paper_color && !size.best_judgement"
                                :style="{
                                    'background-color': size.paper_color
                                }"
                            ></div>
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ size.amount | currency }}
                        </div>
                        <div class="actions" v-if="editable">
                            <a
                                v-if="showProductDeleteButtons"
                                @click.prevent="removeItem(item.sizes, size)"
                                href="#"
                                title="Remove from Shopping Cart"
                            >
                                <i
                                    class="mdi mdi-delete"
                                    style="color: #f04d7f"
                                />
                            </a>
                        </div>
                        <!-- <div class="actions" v-else>&nbsp;&nbsp;&nbsp;</div> -->
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-for="(file, digital_file_id) in item.digital_files"
                        :key="`digital_file-${digital_file_id}`"
                    >
                        <div class="cart-left">
                            {{ file.name }}
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ file.price | currency }}
                        </div>
                        <div class="actions" v-if="editable">
                            <a
                                v-if="showProductDeleteButtons"
                                href="#"
                                @click.prevent="
                                    removeItem(item.digital_files, file)
                                "
                                title="Remove from Shopping Cart"
                            >
                                <i
                                    class="mdi mdi-delete"
                                    style="color: #f04d7f"
                                />
                            </a>
                        </div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-for="(extra, printed_extra_id) in item.printed_extras"
                        :key="`printed_extra-${printed_extra_id}`"
                    >
                        <div class="cart-left">
                            <b>{{ extra.quantity }}</b> - {{ extra.name }}
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ (extra.price * extra.quantity) | currency }}
                        </div>
                        <div class="actions" v-if="editable">
                            <a
                                v-if="showProductDeleteButtons"
                                @click.prevent="
                                    removeItem(item.printed_extras, extra)
                                "
                                href="#"
                                title="Remove from Shopping Cart"
                            >
                                <i
                                    class="mdi mdi-delete"
                                    style="color: #f04d7f"
                                />
                            </a>
                        </div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-if="item.birthday_posters.length"
                    >
                        <div class="cart-left">
                            <b>{{ item.birthday_posters.length }}</b> - Birthday
                            Posters
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{
                                (item.birthday_posters.length *
                                    item.birthday_posters[0].price)
                                    | currency
                            }}
                        </div>
                        <div class="actions" v-if="editable">
                            <a
                                v-if="showProductDeleteButtons"
                                @click.prevent="removeBirthdayPosters(item)"
                                href="#"
                                title="Remove from Shopping Cart"
                            >
                                <i
                                    class="mdi mdi-delete"
                                    style="color: #f04d7f"
                                />
                            </a>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <h3 class="mt-0 mb-0">Newsletter</h3>
                    <div class="shopping-cart__row">
                        <div class="cart-left">
                            <b>{{ item.quantity }}</b> - Newsletter
                            <span v-if="item.color_type"
                                >({{
                                    item.color_type === ColorTypes.COLORED
                                        ? "Color"
                                        : "Black"
                                }})</span
                            >
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ item.amount | currency }}
                        </div>
                        <div class="actions" v-if="editable">
                            <a
                                v-if="showProductDeleteButtons"
                                @click.prevent="removeItem(orders, item)"
                                href="#"
                                title="Remove from Shopping Cart"
                            >
                                <i
                                    class="mdi mdi-delete"
                                    style="color: #f04d7f"
                                />
                            </a>
                        </div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-for="(file, file_id) in item.digital_files"
                        :key="`file-${file_id}`"
                    >
                        <div class="cart-left">
                            {{ file.name }}
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ file.price | currency }}
                        </div>
                        <div class="actions" v-if="editable">
                            <a
                                @click.prevent="
                                    removeItem(item.digital_files, file)
                                "
                                href="#"
                                v-if="
                                    file._can_remove && showProductDeleteButtons
                                "
                                title="Remove from Shopping Cart"
                            >
                                <i
                                    class="mdi mdi-delete"
                                    style="color: #f04d7f"
                                />
                            </a>
                        </div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-if="newsletterPhotoAmount > 0"
                    >
                        <div class="cart-left">
                            <b>{{ newsletterPhotoCount }}</b> - Photos Uploaded
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ newsletterPhotoAmount | currency }}
                        </div>
                        <div class="actions" v-if="editable"></div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-if="
                            $store.state.current_community.newsletter_type_id ==
                                4 && newsletterPhotoAmount > 0
                        "
                    >
                        <div class="cart-left">
                            <b>{{
                                newsletterPhotoCount <= 5
                                    ? newsletterPhotoCount
                                    : 5
                            }}</b>
                            - Photos Uploaded Discount
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            ({{
                                (newsletterPhotoCount <= 5
                                    ? newsletterPhotoAmount
                                    : (newsletterPhotoAmount /
                                          newsletterPhotoCount) *
                                      5) | currency
                            }})
                        </div>
                        <div class="actions" v-if="editable"></div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-if="newsletterPhotoPageAmount > 0"
                    >
                        <div class="cart-left">
                            <b>{{ newsletterPhotoPageCount }}</b> - Photo Page
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ newsletterPhotoPageAmount | currency }}
                        </div>
                        <div class="actions" v-if="editable"></div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-for="(extra, extra_id) in item.printed_extras"
                        :key="`extra-${extra_id}`"
                    >
                        <div class="cart-left">
                            <b>{{ extra.quantity }}</b> - {{ extra.name }}
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{ (extra.price * extra.quantity) | currency }}
                        </div>
                        <div class="actions" v-if="editable">
                            <a
                                v-if="showProductDeleteButtons"
                                @click.prevent="
                                    removeItem(item.printed_extras, extra)
                                "
                                href="#"
                                title="Remove from Shopping Cart"
                            >
                                <i
                                    class="mdi mdi-delete"
                                    style="color: #f04d7f"
                                />
                            </a>
                        </div>
                    </div>
                    <div
                        class="shopping-cart__row"
                        v-if="item.birthday_posters.length"
                    >
                        <div class="cart-left">
                            <b>{{ item.birthday_posters.length }}</b> - Birthday
                            Posters
                        </div>
                        <div class="cart-dots"></div>
                        <div class="cart-right">
                            {{
                                (item.birthday_posters.length *
                                    item.birthday_posters[0].price)
                                    | currency
                            }}
                        </div>
                        <div class="actions" v-if="editable">
                            <a
                                v-if="showProductDeleteButtons"
                                @click.prevent="removeBirthdayPosters(item)"
                                href="#"
                                title="Remove from Shopping Cart"
                            >
                                <i
                                    class="mdi mdi-delete"
                                    style="color: #f04d7f"
                                />
                            </a>
                        </div>
                    </div>
                </template>
            </div>
            <div class="mt-10"></div>
        </template>
        <div v-if="showProductTotal" class="shopping-cart__row bold">
            <div class="cart-left">Product Total</div>
            <div class="cart-dots"></div>
            <div class="cart-right">
                {{ productTotal | currency }}
            </div>
            <div class="actions" v-if="editable"></div>
        </div>
        <template v-if="showSummary">
            <div
                class="shopping-cart__row"
                :class="{ bold: total.bold }"
                v-for="(total, total_id) in computedTotals"
                :key="`total-${total_id}`"
            >
                <div class="cart-left">
                    {{ total.label }}
                </div>
                <div class="cart-dots"></div>
                <div class="cart-right">
                    <span v-if="total.loading"
                        ><i class="mdi mdi-loading mdi-spin"
                    /></span>
                    <span
                        v-else-if="
                            total.amount == null &&
                            total.label === 'Shipping' &&
                            shipping_loaded
                        "
                        >TBD&nbsp;*</span
                    >
                    <span v-else-if="total.amount == null">$--.--</span>
                    <span v-else-if="total.subtract"
                        >(-{{ total.amount | currency }})</span
                    >
                    <span v-else>{{ total.amount | currency }}</span>
                </div>
                <div class="actions" v-if="editable">
                    <a
                        v-if="total.remove_coupon"
                        @click.prevent="removeCoupon(coupon.id)"
                        href="#"
                        title="Remove from Shopping Cart"
                    >
                        <i class="mdi mdi-delete" style="color: #f04d7f" />
                    </a>
                </div>
                <div v-if="total.label === 'Cart Total'">
                    <br />
                    <hr />
                </div>
            </div>
            <div
                v-if="!shipping_rate && showShipping && shipping_loaded"
                class="shipping-disclaimer"
            >
                * Shipping to be determined
            </div>
            <div class="mt-10">
                <div v-if="!coupon">
                    <h4 class="mt-0 mb-0 d-inline-block">Coupon Code</h4>
                    <el-input
                        v-model="couponCode"
                        class="d-inline-block w-40 el-input--uppercase"
                    ></el-input>
                    <el-button
                        type="success"
                        round
                        class="float-right w-25 coupon-btn"
                        @click="applyCode(couponCode)"
                        >Apply</el-button
                    >
                </div>
            </div>
        </template>
        <template v-if="hasMissingNewsletter || hasMissingCalendar">
            <p class="text-error">
                To place your order, you must add
                <span v-if="hasMissingCalendar">all of your calendars</span>
                <span v-if="hasMissingCalendar && hasMissingNewsletter"
                    >and</span
                >
                <span v-if="hasMissingNewsletter"
                    ><span v-if="!hasMissingCalendar">your</span>
                    newsletter</span
                >
                to the shopping cart. Click below to return to your dashboard
                and complete the order.
            </p>
            <el-button
                type="primary"
                round
                icon="mdi mdi-home"
                v-if="hasMissingCalendar || hasMissingNewsletter"
                @click="$router.push({ name: Routes.HOME })"
                >Home
            </el-button>
        </template>
        <div
            class="mt-10"
            v-if="
                !hasMissingCalendar &&
                !hasMissingNewsletter &&
                showCheckoutButton
            "
        >
            <el-button
                class="mb-10 btn-block"
                type="primary"
                icon="mdi mdi-cash"
                round
                @click="$router.push({ name: Routes.CHECKOUT })"
                >Proceed to Checkout
            </el-button>
        </div>
    </div>
</template>

<script>
import * as ColorTypes from "@/constants/color-types";
import * as Routes from "@/constants/routes";
import * as SizeTypes from "@/constants/size-types";
import cart_updated_listener from "@/mixins/cart-updated-listener";
import cart_mixin from "@/mixins/cart_mixin";
import * as Actions from "@/store/constants/actions";
import * as Mutations from "@/store/constants/mutations";
import Utils from "@/utils";
import _ from "lodash";
import moment from "moment";
import { mapActions, mapState } from "vuex";

export default {
    mixins: [cart_mixin, cart_updated_listener],
    props: {
        withHeader: {
            type: Boolean,
            default: true
        },
        rushProcessing: {
            type: Boolean,
            default: false
        },
        showCheckoutButton: {
            type: Boolean,
            default: false
        },
        showSummary: {
            type: Boolean,
            default: true
        },
        showProducts: {
            type: Boolean,
            default: true
        },
        showProductDeleteButtons: {
            type: Boolean,
            default: true
        },
        showProductTotal: {
            type: Boolean,
            default: false
        },
        customShipping: {
            type: Boolean,
            default: false
        },
        showGrandTotal: {
            type: Boolean,
            default: true
        },
        showAddProducts: {
            type: Boolean,
            default: false
        },
        showShipping: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            Routes,
            ColorTypes,
            SizeTypes,
            orders: [],
            loading: false,
            loadingShipping: false,
            shipping_rate: null,
            editable: true,
            couponCode: null,
            coupon: null,
            discountCoupons: null,
            prepaid_subscription: false,
            shipping_loaded: false
        };
    },
    created() {
        //this.updateOrders();
        this.getActiveCoupon();
    },
    computed: {
        ...mapState([
            "current_order",
            "handling_charge",
            "loading_handling_charge"
        ]),
        canCheckout() {
            return this.orders.length;
        },
        computedTotals() {
            if (!this.showGrandTotal) {
                //update cartTotals with label "Grand Total" to change amount to null
                this.cartTotals.forEach((item) => {
                    if (item.label === "Grand Total") {
                        item.amount = null;
                    }
                });

                return this.cartTotals;
            }
            //if !showShipping then remove total for shipping
            if (!this.showShipping) {
                this.cartTotals = this.cartTotals.filter(
                    (item) => item.label !== "Shipping"
                );
            }
            return this.cartTotals;
        }
    },
    methods: {
        ...mapActions(["fetchHandlingCharge"]),
        onCartUpdated() {
            if (!this.$store.state.cart.shipping_in_progress) {
                this.updateOrders();
            }
        },
        getCart() {
            this.loading = true;
            this.$store
                .dispatch(Actions.FETCH_CART)
                .then(() => {
                    this.updateOrders();
                })
                .finally(() => (this.loading = false));
            this.$store
                .dispatch(Actions.FETCH_CURRENT_ORDER)
                .then((response) => {
                    this.shipping_rate = response.data.shipping_rate;
                });
        },
        updateOrders() {
            this.orderForm.rush_processing =
                this.$store.state.cart.rush_processing;
            this.editable = this.$store.state.cart.editable;
            this.orders = _.cloneDeep(this.$store.state.cart.orders);
            this.coupon = this.$store.state.current_community.active_coupon;
            // Only compute shipping if not already being handled by parent
            if (this.editable && !this.$store.state.cart.shipping_in_progress) {
                this.$store.commit("SET_SHIPPING_IN_PROGRESS", true);
                this.computeShipping().finally(() => {
                    this.$store.commit("SET_SHIPPING_IN_PROGRESS", false);
                });
            }
        },
        submitCart() {
            return window.axios
                .put(`/web-api/cart`, {
                    orders: this.orders
                })
                .then((response) => {
                    this.$store.commit(Mutations.SET_CART, response.data);
                    this.orders = _.cloneDeep(response.data.orders);
                    this.computeShipping();
                    return response;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        removeItem(arr, item) {
            //console.log({arr, item});
            this.$confirm(
                "Are you sure you want to remove item from shopping cart?",
                "Warning",
                {
                    confirmButtonText: "Remove",
                    confirmButtonClass: "el-button--danger",
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            )
                .then(() => {
                    Utils.arrayDelete(arr, item);
                    return this.submitCart();
                })
                .catch(() => {
                    //user cancelled
                });
        },
        removeBirthdayPosters(item) {
            this.$confirm(
                "Are you sure you want to remove item from shopping cart?",
                "Warning",
                {
                    confirmButtonText: "Remove",
                    confirmButtonClass: "el-button--danger",
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            )
                .then(() => {
                    item.birthday_posters = [];
                    this.submitCart();
                })
                .catch(() => {
                    //user cancelled
                });
        },
        refresh() {
            this.getCart();
        },
        computeShipping(forceRecalculate = false) {
            if (!this.orders.length || !this.showSummary) {
                return Promise.resolve();
            }

            this.$emit("loading-shipping", true);
            this.loadingShipping = true;

            return window.axios
                .post(`/web-api/cart/compute-shipping-rate`, {
                    force_recalculate: forceRecalculate
                })
                .then((response) => {
                    if (this.customShipping) {
                        this.fetchHandlingCharge();
                        return;
                    }
                    this.shipping_rate = response.data;
                    this.$emit("compute-shipping", this.shipping_rate);
                })
                .catch((error) => {
                    console.error("Shipping calculation error:", error);
                    this.shipping_rate = null;
                    this.$emit("compute-shipping", null);
                })
                .finally(() => {
                    this.loadingShipping = false;
                    this.$emit("loading-shipping", false);
                    this.shipping_loaded = true;
                    this.$emit("shipping-loaded", true);
                    this.computeTax();
                });
        },
        computeTax() {
            this.$store.dispatch(Actions.FETCH_CART_TAX);
        },
        updateCoupon(id, community_id) {
            window.axios
                .put(
                    `/web-api/apply-coupon/${id}?include=duration,types,communities,logs`,
                    {
                        community_id: community_id
                    }
                )
                .then((response) => {
                    if (response.data) {
                        this.coupon = response.data;
                        this.$store.commit(Mutations.SET_COUPON, response.data);
                    } else {
                        this.showAlert("Coupon has expired");
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        applyCode(code) {
            if (!code) {
                return;
            }
            code = code.toUpperCase().trim();
            window.axios
                .get(
                    `/web-api/coupon/${code}/search?include=duration,types,communities`
                )
                .then((response) => {
                    if (response.data) {
                        let validity = moment(response.data.valid_at).diff(
                            moment(),
                            "minutes"
                        );
                        if (validity > 0) {
                            if (
                                this.$store.state.current_community
                                    .subscription_interval == 12
                            ) {
                                let subscription_validity = moment
                                    .utc(
                                        this.$store.state.current_community
                                            .subscription_start
                                    )
                                    .add(1, "y");
                                let diff = moment(subscription_validity).diff(
                                    moment(),
                                    "minutes"
                                );
                                for (
                                    var i = 0;
                                    i < response.data.types.data.length;
                                    i++
                                ) {
                                    if (
                                        response.data.types.data[i].name ==
                                            "Free Subscription" &&
                                        diff > 0
                                    ) {
                                        this.prepaid_subscription = true;
                                    } else {
                                        this.prepaid_subscription = false;
                                    }
                                }
                                if (this.prepaid_subscription) {
                                    this.showAlert(
                                        "Your subscription is prepaid and will not be discounted by the coupon code."
                                    );
                                } else {
                                    this.updateCoupon(
                                        response.data.id,
                                        this.$store.state.current_community.id
                                    );
                                    this.computeTax();
                                }
                            } else {
                                this.updateCoupon(
                                    response.data.id,
                                    this.$store.state.current_community.id
                                );
                                this.computeTax();
                            }
                        } else {
                            this.showAlert("Coupon has expired");
                        }
                    } else {
                        this.showAlert("Coupon not found");
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getActiveCoupon() {
            return window.axios
                .get(
                    `/web-api/active-coupon/${this.$store.state.current_community.id}?include=duration,types,communities,logs`
                )
                .then((response) => {
                    this.$store.commit(Mutations.SET_COUPON, response.data);
                    this.coupon = response.data;
                    this.updateOrders();
                })
                .catch((e) => {
                    console.log(e);
                    this.updateOrders();
                });
        },
        removeCoupon(id) {
            window.axios
                .put(
                    `/web-api/restore-coupon/${id}?include=duration,types,communities,logs`,
                    {
                        community_id: this.$store.state.current_community.id
                    }
                )
                .then(() => {
                    this.coupon = null;
                    this.couponCode = null;
                    this.$store.commit(Mutations.SET_COUPON, "");
                    this.computeTax();
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        showAlert(msg) {
            return this.$toastr("add", {
                title: "Alert!",
                msg: msg,
                clickClose: true,
                position: "toast-top-right",
                type: "warning"
            });
        },
        goToAddCalendarProducts(calendar_id) {
            // Navigate to calendar edit page with step 5 (place order)
            this.$router.push({
                name: "EditCalendar",
                params: {
                    id: calendar_id // Make sure you have access to calendar_id
                },
                query: { step: 5 }
            });
        }
    },
    watch: {
        rushProcessing(value) {
            this.orderForm.rush_processing = value;
        },
        "orderForm.rush_processing"(value) {
            this.$emit("update:rushProcessing", value);
        },
        cartGrandTotal(value) {
            this.$emit("grand-total-updated", value);
        },
        customShipping(value) {
            this.orderForm.custom_shipping = value;
            if (value) {
                this.shipping_rate = null;
                this.orderForm.shipping_rate_id = null;
                this.fetchHandlingCharge();
            } else {
                this.computeShipping();
            }
        }
    }
};
</script>

<style scoped>
.w-40 {
    width: 40%;
}
.w-25 {
    width: 25%;
}
.coupon-btn {
    padding: 10px 20px;
}
.shipping-disclaimer {
    font-size: 12px;
    color: #606266;
    margin-top: 8px;
    font-style: italic;
    text-align: right; 
    padding-right: 8px; 
}
</style>
